import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { ORDER_STATUS, PrimarySecondaryString } from '../../../../../../../constants/external-constants';
import { convertToDate, toYesOrNo } from '../../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../../request-on-behalf-details.component"
import Translation from "../../../../../../common/translation/translation.component";
import Icons from "../../../../../../icon";

export class NewCircuitDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }
    editRequest = (orderStatusId, endUserId, requestorId, path) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);

        return editableRequest && isRequestOwner && !path;
    }
    formatNumber(value, decimals = 2) {
        if (value === null || value === undefined || value === '') return '';
        const num = Number(value);
        return isNaN(num) ? '' : num.toFixed(decimals);
    }
    render() {
        const { data, openRequestModal, path } = this.props;
        const { Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId } } = data || {};

        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                {this.editRequest(OrderStatusId, EndUserId, RequestorId, path) ?  
                        <>
                        <Icons
                            customClassName="pen-to-square"
                            name="pen-to-square"
                            size="20px"
                            containerClass="icon-circle-plus-container"
                            onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                            labelValue={"Update Order Request"}
                            labelClass="order-detail-edit-label"                                                              
                        />
                        </>
                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="capital_location" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                {data.LocationAddress.LocationId > 0 ? <td>{data.LocationAddress.CountryName}</td> : null}
                            </tr>
                            <tr>
                                <td><Translation translationKey="billing_address" /></td>
                                <td>{data.BillingAddress.LocationName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="location_address" /></td>
                                <td>{data.LocationAddress != null ? data.LocationAddress.DeliveryAddress : null}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="demarc_location_1" /></td>
                                <td>{data.DemarcLocation}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="location_address_p2p" /></td>
                                <td>{data.LocationP2P != null ? data.LocationP2P.DeliveryAddress : null}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="demarc_location_2" /></td>
                                <td>{data.DemarcLocationPTP}</td>
                            </tr>
                            {
                                //<tr>
                                //    <td>Company Code</td>
                                //    <td>{data.Order.CostCenter}</td>
                                //</tr>
                            }
                            <tr>
                                <td><Translation translationKey="gl_code" /></td>
                                <td>{data?.BusinessWireline?.CircuitCostAllocations?.GLCode}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="cost_center" /></td>
                                <td>{data?.BusinessWireline?.CircuitCostAllocations?.CostCode}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="capital_pos" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="vendor" /></td>
                                <td>{data.Subscription.Vendor}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="category" /></td>
                                <td>{data.Subscription.ItemUse}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="circuit_type" /></td>
                                <td>{data.Subscription.CircuitType}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="sub_circuit_type" /></td>
                                <td>{data.Subscription.SubCircuitType}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="primary_secondary" /></td>
                                <td>{data.Subscription.PrimarySecondary}</td>
                            </tr>
                            {data.Subscription.PrimarySecondary.toLowerCase() == PrimarySecondaryString.secondary && data.Subscription.PrimarySecondary.toLowerCase() != PrimarySecondaryString.both && 

                                <tr>
                                    <td><Translation translationKey="btn" /></td>
                                    <td>{data.Subscription.BtnText}</td>
                                </tr>
                            }
                            <tr>
                                <td><Translation translationKey="mrc" /></td>
                                <td>{this.formatNumber(data.Subscription.Mrc)}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="nrc" /></td>
                                <td>{this.formatNumber(data.Subscription.Nrc)}</td>
                            </tr>

                            {data.Subscription.PrimarySecondary.toLowerCase() == PrimarySecondaryString.both &&

                                <tr>
                                    <td><Translation translationKey="mrc2" /></td>
                                    <td>{this.formatNumber(data.Subscription.Mrc2)}</td>
                                </tr>
                            }
                            {data.Subscription.PrimarySecondary.toLowerCase() == PrimarySecondaryString.both && 
                                <tr>
                                    <td><Translation translationKey="nrc2" /></td>
                                    <td>{this.formatNumber(data.Subscription.Nrc2)}</td>
                                </tr>
                            }
                            {data.Subscription.PrimarySecondary.toLowerCase() &&
                                <tr>
                                    <td><Translation translationKey="capital_total_cost" /></td>
                                    <td>{this.formatNumber(data.Subscription.Mrc + data.Subscription.Nrc + data.Subscription.Mrc2 + data.Subscription.Nrc2)}</td>

                                </tr>
                            }
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title">
                        <Translation translationKey="capital_business_justification" />
                    </h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="approver" /></td>
                                <td>{data.WireLineApprover.Email}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="need_by_date" /></td>
                                <td>{convertToDate(data.Order.NeedByDate, 'DD MMM YYYY')}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>{data.BusinessJustification.PurposeOfUse}</td>
                            </tr>   
                            <tr>
                                <td><Translation translationKey="expedite_request" /></td>
                                <td>{toYesOrNo(data.BusinessWireline.ExpediteRequest)}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <OrderRequestFiles files={data.Order.OrderFileNames} />
                </div>
            </div>
        );
    }
}